'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClassName;

var _copyProps = require('./copy-props');

var _copyProps2 = _interopRequireDefault(_copyProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClassName(inProps, klass) {
  var props = (0, _copyProps2.default)(inProps);
  props.className = props.className ? klass + ' ' + props.className : klass;

  return props;
}


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/utils/add-class-name.js
 **/